<template>
  <div class="modal_wrap full_modal on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <header class="header">
          <div class="inner">
            <div class="left"></div>
            <h1 class="h1">
              {{ shop.name }}
            </h1>
            <div class="right">
              <button class="h_btn i_x" @click="$router.go(-1)"></button>
            </div>
          </div>
        </header>
        <main class="main" role="main">
          <ShopMap :lat="shop.latitude" :lng="shop.longitude" />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import ShopMap from '@/common/components/shop/ShopMap';

export default {
  name: 'shop-location',
  components: {
    ShopMap,
  },
  created() {
    this[shopTypes.FETCH_SHOP]({ id: this.$route.params.id });
  },
  computed: {
    ...mapGetters({ shop: shopTypes.SHOP }),
  },
  methods: {
    ...mapActions([shopTypes.FETCH_SHOP]),
  },
};
</script>

<style>
#shopMap {
  height: 100%;
}
</style>
